// Genres éligibles à la certification vidéo : femme (2) + tous les couples (3, 4, 5).
//
// MIROIR de CERTIF_ELIGIBLE_GENDERS (voissa-api-rest, const/certifications.js), qui qualifie le
// grant `certified`. Le front ne fait qu'AFFICHER : il décide
// à qui proposer la certification comme alternative gratuite, l'API reste seule juge des droits
// réellement accordés. Les deux listes doivent rester identiques — sinon on propose la certif à
// des profils qui n'en tireront rien, ou on la cache à des profils qui y ont droit.
const CERTIF_ELIGIBLE_GENDERS = [2, 3, 4, 5];

export const isCertifEligibleGender = (gender) =>
    CERTIF_ELIGIBLE_GENDERS.includes(Number(gender));

export default CERTIF_ELIGIBLE_GENDERS;
